export const commonEnvironment = {
  API_KEY: '',
  AUTH_COOKIE: 'wok_auth_token',
  LAST_BUILD_TIME: '###Fri Apr 05 2024 12:41:34 GMT+0000###',
  HTTP_RESPONSE_TOTAL_COUNT: 'X-Total-Count'
};
